// This function registers a service worker if supported by the browser
export function register(config) {
  if ('serviceWorker' in navigator) {
    // The URL of the service worker file
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    // Wait for the page to load before registering the service worker
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('Service Worker registered:', registration);

          if (registration.waiting) {
            console.log('A new version of the app is available.');
          }

          // Optionally handle updates
          if (config && config.onUpdate) {
            config.onUpdate(registration);
          }
          if (config && config.onSuccess) {
            config.onSuccess(registration);
          }
        })
        .catch((error) => {
          console.error('Error registering the Service Worker:', error);
        });
    });
  }
}

// This function unregisters the service worker
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
